import React from 'react';
import { Grid, Link } from '@material-ui/core';
import i18n from 'i18n-js';
import { Card } from 'components/UI';
import { useStyles } from './common.styled';
import { buildUrl } from 'utils';
import { useSelector } from 'react-redux';

export const AccountStatementWidget = ({ accountStatement }) => {
  const { id, due_time } = accountStatement;
  const classes = useStyles();
  const locale = useSelector(
    (state) => state?.organizations?.organization?.locale || 'en-US'
  ).replace('_', '-');

  const dueTime = new Date(due_time);
  const month = new Intl.DateTimeFormat(locale, { month: 'long' }).format(dueTime);

  return (
    <Card title={i18n.t('account_statement.title')}>
      <Grid container>
        <Link className={classes.link} color="primary" href={buildUrl(`/account-statement/${id}`)}>
          {month} - {i18n.t('common.due_time')} {dueTime.toLocaleDateString(locale)}
        </Link>
      </Grid>
    </Card>
  );
};
